import { useQuery } from '@vue/apollo-composable'
import GetCustomersSpecialPricesQuery from '../graphql/GetCustomersSpecialPricesQuery.graphql'

export const useGetCustomersSpecialPrices = (companyId) => {
	const { result, loading, error, refetch } = useQuery(
		GetCustomersSpecialPricesQuery,
		{
			company_id: companyId,
		},
		{
			fetchPolicy: 'cache-and-network',
		},
	)

	return {
		customers: result,
		loading,
		error,
		refetch,
	}
}
